import { ElementRef } from '@angular/core';
import { GeoCoordinates } from '@sc/data-access-models';

export class BaseGMapOverlay extends google.maps.OverlayView {
  private _gmap: google.maps.Map;
  public set gmap(newGMap: google.maps.Map) {
    if (!this._gmap && !!newGMap) {
      this._gmap = newGMap;
      this.setMap(newGMap);
    }
  }

  private currentPos: GeoCoordinates;
  public set position(newPos: GeoCoordinates) {
    this.currentPos = newPos;
  }

  protected additionalClasses: string[] = [];
  protected elDiv?: HTMLElement;

  constructor(
    private readonly thisElemRef: ElementRef,
    private readonly customDivClass = ''
  ) {
    super();

    this.thisElemRef.nativeElement.style.visibility = 'hidden';
  }

  protected updateClass(...newClasses: string[]) {
    if (this.elDiv) {
      this.additionalClasses.forEach((additionalClass) => {
        if (additionalClass) {
          this.elDiv.classList.remove(additionalClass);
        }
      });
      this.additionalClasses = newClasses;
      this.additionalClasses.forEach((additionalClass) => {
        if (additionalClass) {
          this.elDiv.classList.add(additionalClass);
        }
      });
    }
  }

  public onAdd() {
    const innerDiv = document.createElement('div');
    innerDiv.style.display = 'flex';
    innerDiv.style.justifyContent = 'center';
    innerDiv.style.alignItems = 'center';
    innerDiv.style.height = '100%';
    innerDiv.style.width = '100%';

    innerDiv.appendChild(this.thisElemRef.nativeElement);

    this.elDiv = document.createElement('div');
    this.elDiv.style.position = 'absolute';
    this.elDiv.className =
      this.elDiv.className + ' gmap-overlay-top-element ' + this.customDivClass;

    this.elDiv.appendChild(innerDiv);

    const panes = this.getPanes();
    panes.floatPane.appendChild(this.elDiv);

    this.thisElemRef.nativeElement.style.visibility = 'visible';
  }

  public draw() {
    const point = this.getProjection().fromLatLngToDivPixel(
      new google.maps.LatLng(this.currentPos.lat, this.currentPos.lon)
    );

    if (this.elDiv) {
      this.elDiv.style.left = point.x - 1 + 'px';
      this.elDiv.style.top = point.y - 1 + 'px';
      this.elDiv.style.width = '2px';
      this.elDiv.style.height = '2px';
    }
  }

  public onRemove() {
    if (this.elDiv) {
      this.elDiv.parentNode.removeChild(this.elDiv);
      delete this.elDiv;
      this.setMap(null);
    }
  }
}
